import { Component, Input } from '@angular/core';

// Reusable "colored notch + title/source header + projected content" card shell.
@Component({
  selector: 'app-v3-notch-card',
  imports: [],
  standalone: true,
  templateUrl: './v3-notch-card.html',
  styleUrl: './v3-notch-card.scss',
})
export class V3NotchCard {
  /** Header row is omitted entirely when empty — leave unset for pure projected content. */
  @Input() title = '';
  /** Right-aligned header text, e.g. "37 Häuser · TIPRANKS LTD.". */
  @Input() source: string | null = null;
  @Input() notchColor = 'var(--v3-positive)';
}
